<template>
	<!-- NOTIFICATIONS -->
	<vs-dropdown
		vs-custom-content
		vs-trigger-click
		class="cursor-pointer"
	>
		<feather-icon
			icon="BellIcon"
			class="cursor-pointer mt-1 sm:mr-6 mr-2"
			:badge="unCompletedTasks.length"
		/>

		<vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

			<div class="notification-top text-center p-5 bg-primary text-white">
				<h3 class="text-white">{{ unCompletedTasks.length }} Megoldatlan</h3>
				<p class="opacity-75">Feladat</p>
			</div>

			<VuePerfectScrollbar
				ref="mainSidebarPs"
				class="scroll-area--nofications-dropdown p-0 mb-10"
				:settings="settings"
				:key="$vs.rtl"
				v-if="notifications"
			>
				<ul class="bordered-items">
					<li
						v-for="notification in notifications.tasks"
						:key="notification.id"
						class="flex justify-between px-4 py-4 notification cursor-pointer"
						@click="selectNotification(notification.transaction.id)"
					>
						<div class="flex items-start">
							<feather-icon
								icon="MessageSquareIcon"
								:svgClasses="[`text-${getColor(notification.status)}`, 'stroke-current mr-1 h-6 w-6']"
							></feather-icon>
							<div class="mx-2">
								<span
									class="font-medium block notification-title"
									:class="[`text-${getColor(notification.status)}`]"
								>{{ notification.phase.name }}</span>
								<small><b>Ügylet azonosító:</b> {{ notification.transaction.code }}</small>
								<p>
									<small><b>Határidő:</b> {{ notification.deadline }}</small>
								</p>
							</div>
						</div>
						<small class="
									mt-1
									whitespace-no-wrap">{{ elapsedTime(notification.createdAt) }}</small>
					</li>
				</ul>
			</VuePerfectScrollbar>

			<div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
				<span>Összes megtekintése</span>
			</div>
		</vs-dropdown-menu>
	</vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
	components: {
		VuePerfectScrollbar
	},
	data() {
		return {
			notifications: {
				tasks: []
			},
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: .60,
			},
		}
	},
	computed: {
		unCompletedTasks() {
			return this.notifications.tasks.filter(notification => {
				return notification.status != 'done';
			})
		}
	},
	methods: {
		fetchNotifications() {
			console.log('FETCH NOTI');
			this.$http.get('/api/auth/notifications')
				.then((response) => {
					console.log(response.data);
					this.notifications = response.data.notifications
				})
				.catch((error) => { console.log(error) })
		},
		selectNotification(transactionId) {
			if (this.$route.params.id != transactionId) {
				this.$router.push('/ugylet/' + transactionId)
			}
		},
		getColor(status) {
			switch (status) {
				case 'in_progress':
					return 'warning'

				case 'done':
					return 'success'

				case 'obstacle':
					return 'danger'

				default:
					return 'dark'
					break;
			}
		},
		elapsedTime(startTime) {
			let x = new Date(startTime)
			let now = new Date()
			var timeDiff = now - x
			timeDiff /= 1000

			var seconds = Math.round(timeDiff)
			timeDiff = Math.floor(timeDiff / 60)

			var minutes = Math.round(timeDiff % 60)
			timeDiff = Math.floor(timeDiff / 60)

			var hours = Math.round(timeDiff % 24)
			timeDiff = Math.floor(timeDiff / 24)

			var days = Math.round(timeDiff % 365)
			timeDiff = Math.floor(timeDiff / 365)

			var years = timeDiff

			if (years > 0) {
				return years + (years > 1 ? ' éve ' : ' éve ')
			} else if (days > 0) {
				return days + (days > 1 ? ' napja ' : ' napja ')
			} else if (hours > 0) {
				return hours + (hours > 1 ? ' órája ' : ' órája ')
			} else if (minutes > 0) {
				return minutes + (minutes > 1 ? ' perce ' : ' perce ')
			} else if (seconds > 0) {
				return seconds + (seconds > 1 ? ' másodperce' : 'épp most')
			}

			return 'Just Now'
		},
		// Method for creating dummy notification time
		randomDate({ hr, min, sec }) {
			let date = new Date()

			if (hr) date.setHours(date.getHours() - hr)
			if (min) date.setMinutes(date.getMinutes() - min)
			if (sec) date.setSeconds(date.getSeconds() - sec)

			return date
		}
	},
	mounted() {
		// window.setInterval(() => {
		// 	this.fetchNotifications()
		// }, 10000);
		this.fetchNotifications()
	}
}

</script>

